var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19.267 7.544-6.32-6.325a4.172 4.172 0 0 0-5.894 0L.733 7.544A2.484 2.484 0 0 0 0 9.313v8.185A2.5 2.5 0 0 0 2.5 20h15a2.5 2.5 0 0 0 2.5-2.502V9.313a2.484 2.484 0 0 0-.733-1.769ZM12.5 18.332h-5v-3.28a2.5 2.5 0 1 1 5 0v3.28Zm5.833-.834c0 .46-.373.834-.833.834h-3.333v-3.28A4.168 4.168 0 0 0 10 10.882a4.168 4.168 0 0 0-4.167 4.17v3.28H2.5a.834.834 0 0 1-.833-.834V9.313a.84.84 0 0 1 .244-.59L8.23 2.4a2.506 2.506 0 0 1 3.537 0l6.321 6.326a.84.84 0 0 1 .244.587v8.185Z",
    fillRule: "evenodd",
    "data-name": "home"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.5fb35b039d2701345809f712cd5922e7.svg";
export { ForwardRef as ReactComponent };